module.exports = require("@agm/core/services/managers/data-layer-manager");